<template>
  <article
    :ref="`article-${article.id}`"
    :class="['collapsible-article', { active: expanded }]"
  >
    <header class="header" @click="expanded = !expanded">
      <h1>{{ article.title }}</h1>
      <div class="arrow"></div>
    </header>
    <div class="body" v-if="expanded">
      <div v-html="$options.filters.nl2p(article.body)" />
      <div v-if="article.attachments">
        <div
          class="attachment"
          v-for="(filename, index) in article.attachments.split(' ')"
          :key="index"
        >
          <img
            class="img-responsive"
            @click="windowOpen(docsResource(filename))"
            :src="docsResource(filename)"
          />
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import { mapMutations } from "vuex"
export default {
  name: "CollapsibleArticle",
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    if (this.$route.hash === `#${this.article.id}`) {
      this.expanded = true
      var element = this.$refs[`article-${this.article.id}`]

      window.scrollTo(0, element.offsetTop)
    }
  },
  data() {
    return {
      expanded: false,
    }
  },
  methods: {
    ...mapMutations(["windowOpen"]),
  },
}
</script>
